export default function Contact() {
  return (
    <div>
      <h1>Contacto</h1>
      <p>Puedes colocar aquí tu formulario o información de contacto.</p>
    </div>
  );
}
